// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__Nae2Y","userIcon":"styles_userIcon__veRvz","menu":"styles_menu__JVWtA","menuItem":"styles_menuItem__NqfSx"};